import { crud, updateWeights } from '@/api/assignmenttypes';

const state = {};

const getters = {};

const actions = {
	getAssignmentTypes() {
		return crud.all();
	},

	getAssignmentType(_, typeId) {
		return crud.find(typeId);
	},

	createAssignmentType(_, payload) {
		return crud.create(payload);
	},

	updateAssignmentType(_, { typeId, payload }) {
		return crud.update(typeId, payload);
	},

	deleteAssignmentType(_, typeId) {
		return crud.delete(typeId);
	},

	updateWeights(_, payload) {
		return updateWeights(payload);
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
